module.exports = __webpack_public_path__ + "img/logo-swimming-nz-white.8f3a43c9.png";